/* ============================================================
   商品カード共通コンポーネント — カート投入（document 委譲・1本化）
   ------------------------------------------------------------
   SSOT: docs/spec-product-card-component.md
   マークアップ: snippets/senchado-product-card.liquid
   スタイル:     assets/senchado-product-card.css

   契約（テスト: tests/senchado-cart-add-payload.test.mjs / tests/product-card-cart.spec.js）
     - 数量は 1 固定（カードからは 1 個ずつしか入らない）
     - クリックした瞬間に disabled にする → 連打しても /cart/add.js は1回
     - 先行発売ロック（data-early-locked）と disabled は発火しない
     - 成功時は cart:updated を document に発火（現行 senchado-collection.js と同挙動）
     - 委譲は .senchado-collection__card の中だけに効かせる。
       道具コレクション（.senchado-dougu__card / senchado-collection-dougu.js）は
       独自リスナーのままなので、ここが拾うと二重送信になる。
     - bind は一度きり（section 再読込やスクリプト二重読込でも重複させない）
   ============================================================ */
(function () {
  'use strict';

  // カード共通コンポーネントが出すカードの範囲。ここに含まれないボタンは扱わない。
  var CARD_SELECTOR = '.senchado-collection__card';
  var BOUND_FLAG = '__senchadoProductCardBound';

  /** /cart/add.js の payload。カードからは常に数量1（selling_plan は付けない） */
  function buildCartAddBody(variantId) {
    return { items: [{ id: Number(variantId), quantity: 1 }] };
  }

  function addToCart(button) {
    // 先行発売ロック: Cart Function が Plus 必須で無効＝サーバーガードが無い。
    // disabled 属性を外されてもここで必ず遮断する（防御の二層目）。
    if (button.dataset.earlyLocked === 'true') return;
    if (button.disabled) return;
    if (button.dataset.state === 'loading') return;
    var id = button.dataset.variantId;
    if (!id) return;

    button.disabled = true;
    button.dataset.state = 'loading';
    var original = button.textContent;
    button.textContent = '追加中…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(buildCartAddBody(id))
    }).then(function (res) {
      if (!res.ok) throw new Error('カートに追加できませんでした');
      return res.json();
    }).then(function () {
      button.dataset.state = 'success';
      button.textContent = 'カートに追加しました';
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      setTimeout(function () {
        button.disabled = false;
        delete button.dataset.state;
        button.textContent = original;
      }, 2000);
    }).catch(function () {
      button.disabled = false;
      delete button.dataset.state;
      button.textContent = original;
      alert('カートに追加できませんでした。時間をおいて再度お試しください。');
    });
  }

  function onClick(e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var button = target.closest('[data-add-to-cart]');
    if (!button) return;
    // スコープ: 共通カードのボタンだけ。道具カード等には触らない。
    if (!button.closest(CARD_SELECTOR)) return;
    e.preventDefault();
    addToCart(button);
  }

  function bind() {
    if (document[BOUND_FLAG]) return;
    document[BOUND_FLAG] = true;
    document.addEventListener('click', onClick);
  }

  bind();
})();
